import { render, staticRenderFns } from "./NuovaPrenotazioneProdotto.vue?vue&type=template&id=507b2b35&"
import script from "./NuovaPrenotazioneProdotto.vue?vue&type=script&lang=js&"
export * from "./NuovaPrenotazioneProdotto.vue?vue&type=script&lang=js&"
import style0 from "./NuovaPrenotazioneProdotto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports